/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : Process.jsx
 * description   : {{insert here}}
 * creation date : 24/03/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    Flex,
    View,
    Text,
} from '@aws-amplify/ui-react';

import {
    useComponentContext,
} from '@/components/core';

import {
    ViewPortContainer,
} from '@/components/snippets/CustomDiv';

import {
    ContentContainer,
} from '@/components/snippets/ContentDiv';

import {
    config_page_HOME_process as page_configuration,
} from '@/components/layouts/core';

// Images
import ImageService1 from '@/assets/images/home/handshake.jpg';
import ImageService2 from '@/assets/images/home/office-review.jpg';
import ImageService3 from '@/assets/images/home/train-station-model.jpg';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function ProcessBadge({ title, BadgeImage, children, ...rest }) {
    return (
        <Fragment>
            <View
                className='main-home-process-badge-parent'
                {...rest}
            >
                <Flex
                    direction='column'
                    className='main-home-process-badge'
                >
                    <img
                        src={BadgeImage}
                        alt=''
                        className='main-home-process-badge-image'
                    />

                    <Text
                        className='main-home-process-badge-title'
                    >
                        {title}
                    </Text>

                    <Text
                        className='main-home-process-badge-text'
                    >
                        {children}
                    </Text>
                </Flex>
            </View>
        </Fragment>
    );
}

function Process({ id }) {
    // Component context
    const { ctx } = useComponentContext();

    // Detect private access
    if (false === ctx.api.location.canBeDisplayed(page_configuration)) {
        return null;
    }

    return (
        <Fragment>
            <ContentContainer
                rightAligned={false}
                id={id}
                title='Process' // TODO: Translate message
            >
                <ViewPortContainer>
                    <View
                        width={ctx.theme.tokens.space.relative.full}
                        padding={
                            ctx.api.utils.adaptiveOption(
                                ctx.theme.tokens.space.large,
                                ctx.theme.tokens.space.large,
                                ctx.theme.tokens.space.medium
                            )
                        }
                    >
                        <Text
                            paddingBottom={ctx.theme.tokens.space.medium}
                            className='main-home-text'
                        >
                            {/* TODO: Translate message */}
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus volutpat,
                            arcu et semper hendrerit, lectus nunc interdum elit, sed tempus est lorem non ante.
                            Fusce cursus, sapien mollis bibendum mattis, magna orci sollicitudin metus,
                            eu malesuada erat diam non erat. Mauris enim justo, auctor in est vitae, tempus finibus risus.
                            Cras a augue consectetur, ultrices elit vel, ultricies nisi. Curabitur leo lacus,
                            vehicula vel commodo id, pulvinar vel lacus.
                        </Text>
                    </View>
                </ViewPortContainer>

                <Flex
                    direction='row'
                    wrap='wrap'
                    className='main-home-process-badge-container'
                >
                    <ProcessBadge
                        BadgeImage={ImageService1}
                        // TODO: Translate message
                        title='Review'
                    >
                        {/* TODO: Translate message */}
                        Understanding client philosophy & project needs
                    </ProcessBadge>

                    <ProcessBadge
                        BadgeImage={ImageService2}
                        // TODO: Translate message
                        title='Deploy'
                    >
                        {/* TODO: Translate message */}
                        Through planning & coordination
                    </ProcessBadge>

                    <ProcessBadge
                        BadgeImage={ImageService3}
                        // TODO: Translate message
                        title='Compliance'
                    >
                        {/* TODO: Translate message */}
                        Quality results
                    </ProcessBadge>
                </Flex>
            </ContentContainer>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default Process;



// End of file
